// year-wrapped 动画：当前 stat 索引 + 进场/停留/出场阶段。
import type { SceneData } from '../../api/types'
import type { WrappedData } from './types'

export function wrappedStat(
  d: SceneData,
  time: number,
): { currentStat: number; animPhase: 'enter' | 'hold' | 'exit' } {
  const data = d as unknown as WrappedData
  const interval = 5
  const idx = Math.floor(time / interval)
  if (idx >= (data.stats?.length ?? 0)) return { currentStat: 0, animPhase: 'enter' }
  const subTime = time % interval
  const animPhase = subTime < 0.4 ? 'enter' : subTime > interval - 0.6 ? 'exit' : 'hold'
  return { currentStat: idx, animPhase }
}
